export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  status: Status.INITIAL,
  data: []
}

export default function trafficChannelReducer(state = initialState, action) {
  
  switch (action.type) {
    case ActionType.SET_TRAFFIC_CHANNELS:
      {
        const { trafficChannels } = action.payload;
        return {
          ...state,
          status: Status.LOADED,
          data: [...trafficChannels]
        }
      }
    default:
      return state;
  }
}
